import { api } from './Api';
import axios from 'axios';

export const getProperties = async (params) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.manage_property, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const getPropertyById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    console.log('Fetching property with ID:', id);

    // Fix: Pass ID as proper query parameter with key
    const response = await axios.get(`${api.edit_property}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Property by ID response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching property by ID:', error.response?.data || error.message);
    throw error;
  }
};

export const updateProperty = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');

    // Extract id from data
    const { id, ...propertyData } = data;

    console.log('Updating property with ID:', id, 'Data:', propertyData);

    const response = await axios.post(`${api.add_property}?id=${id}`, propertyData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Update property response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating property:', error.response?.data || error.message);
    throw error;
  }
};

export const getStatus = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_property_status, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const getTypes = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_property_types, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const getFeatures = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_property_features, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const uploadPropertyMedia = async (file, fileType = 'image') => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_type', fileType);
    if (fileType === 'image') {
      formData.append('thumbnail', file);
    }
    console.log('FormData entries:');
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ', pair[1]);
    }
    const response = await axios.post(api.upload_property_img, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading media:', error);

    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }

    throw error;
  }
};

export const uploadPropertyDocuments = async (file, fileType = 'image') => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('name', file.name);
    formData.append('file_type', fileType);
    formData.append('file', file);

    console.log('FormData entries:');
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ', pair[1]);
    }

    const response = await axios.post(api.upload_property_documents, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    }

    throw error;
  }
};
export const addProperty = async (propertyData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_property, propertyData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding property:', error);
    throw error;
  }
};

export const deleteProperty = async (propertyId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(api.delete_property, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        id: propertyId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting property:', error);
    throw error;
  }
};

export const UploadFloorPlans = async (file, fileType = 'image') => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_type', fileType);

    const response = await axios.post(api.upload_floor_image, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading floor plan image:', error);
    throw error;
  }
};

export const ChanegPropertyStatus = async (propertyId, status) => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('id', propertyId);
    formData.append('status', status);

    const response = await axios.post(api.change_property_status, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error changing property status:', error);
    throw error;
  }
};
export const changeFeaturedStatus = async (id, isFeatured) => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('id', id);
    formData.append('is_featured', isFeatured);

    const response = await axios.post(api.change_featured_status, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error changing property status:', error);
    throw error;
  }
};

export const uploadStaggedImages = async (file, isDefault = false) => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    if (isDefault) {
      formData.append('is_default', isDefault);
    }
    const response = await axios.post(api.upload_stage_image, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading staged image:', error);
    throw error;
  }
};

export const getInquiries = async (params) => {
  try {
    const token = localStorage.getItem('token');

    // Debug: Log the parameters being sent
    console.log('API Call - getInquiries params:', params);

    const response = await axios.get(api.get_inquiries, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    // Debug: Log the response
    console.log('API Response - getInquiries:', response.data);

    return response.data;
  } catch (error) {
    console.error('Error fetching inquiries:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};
export const deleteInquiry = async (propertyId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(api.delete_inquiry, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        id: propertyId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting property:', error);
    throw error;
  }
};

export const addInquiry = async (inquiryData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_Inquiry, inquiryData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding property:', error);
    throw error;
  }
};

export const getreviewedProperties = async (params) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_property_dropdown, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const reviewRattings = async (params) => {
  try {
    const token = localStorage.getItem('token');
    const { property_id, page, search } = params;

    const queryParams = new URLSearchParams();
    if (property_id) queryParams.append('property_id', property_id);
    if (page) queryParams.append('page', page);
    if (search) queryParams.append('search', search);

    const queryString = queryParams.toString();
    const url = `${api.review_rattings}${queryString ? `?${queryString}` : ''}`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching review ratings:', error);
    throw error;
  }
};
export const deleteReviews = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(api.delete_review_rating, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        id: id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting property:', error);
    throw error;
  }
};

export const getStates = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_states, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};
export const getCities = async (stateId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_cities, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        state_id: stateId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const get_state_for_properties = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_states_for_add_proeprty, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};
export const get_cities_for_properties = async (stateId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_cities_for_add_proeprty, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        state_id: stateId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};
export const getCitiesTable = async (page = 1, search = '') => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_cities_table, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        page: page,
        search: search
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cities:', error);
    throw error;
  }
};
export const addCities = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    console.log('API Call - FormData:', formData);

    for (let [key, value] of formData.entries()) {
      console.log(`FormData - ${key}:`, value);
    }

    const response = await axios.post(api.add_cities, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding city:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const deleteCity = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(api.delete_cities, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        id: id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting city:', error);
    throw error;
  }
};

export const getAboutPage = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_about_us_page, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching about page:', error);
    throw error;
  }
};

export const updateAboutPage = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.update_about_us_page, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    console.error('Error updating about page:', error);
    throw error;
  }
};

export const markPropertyActive = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.markPropertyActive, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating about page:', error);
    throw error;
  }
};

// Features Category APIs
export const getFeaturesCategory = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_features_category, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features categories:', error);
    throw error;
  }
};

export const AddEditFeaturesCategory = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_features_category, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing features category:', error);
    throw error;
  }
};

export const deleteFeaturesCategory = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_features_category}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features category:', error);
    throw error;
  }
};

export const deleteSubCategory = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_feature_sub_category}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features category:', error);
    throw error;
  }
};

export const getFeaturesList = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_features_list, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const getFeaturesDropdown = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_features_category_dropdown, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const AddEditFeaturesList = async (payload) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(api.add_edit_features_list, payload, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};

export const deleteFeaturesList = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_features_list}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const getSettings = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_settings, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const AddSettings = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_settings, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteSettings = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_settings}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const getSettingsTypes = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_setting_types, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const getAreaUnits = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_area_units, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const getBlogs = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_blogs, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const addEditBlogs = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_blogs, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteBlogs = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_blogs}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const get_blogs_by_slug = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_blogs_by_slug, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const getCityMatch = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_city_state_conditional, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

// TERMS AND CONDITIONS
export const getTermsCondition = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_terms_conditions, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const addTermsCondition = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_terms_conditions, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteTermsCondition = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_terms_conditions}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

// PRIVACY POLICY
export const getPrivacy = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_privacy_policy, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const addPrivacy = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_privacy_policy, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deletePrivacy = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_privacy_policy}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

// CONTACT
export const getContact = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_contacts, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

// BEST PROPERTY
export const saveBestProperty = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_best_property, params, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error saving best property:', error);
    throw error;
  }
};

// FAQS
export const getFaqs = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_faq_list, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const addFaqs = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_faq, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteFaqs = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_faq}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const get_faqs_by_slug = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.add_edit_faq, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

// FAQS  CATEGORY
export const getFaqsCategoryList = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_faq_Category_list, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};
export const getFaqsCategory = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_faq_category, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const addFaqsCategory = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_faq_category, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteFaqsCategory = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_faq_category}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const updateReviewStatus = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.update_review_status, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteContact = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_contacts}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const getTrashedContacts = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_trash_contacts, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

// TRASH API INTEGRATION
export const restoreContact = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.restore_contacts, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};
export const deleteContactPermanently = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.permannetly_delete_contacts}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

// LEAD MANAGEMENT
export const getLeads = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_leads, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching leads:', error);
    throw error;
  }
};

export const getLeadsTypes = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_leads_types, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};
export const addEditleads = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.add_edit_leads, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const deleteLeads = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${api.delete_leads}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting features list:', error);
    throw error;
  }
};

export const respondInquiry = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.send_tour_message, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error responding inquiry', error);
    throw error;
  }
};
export const respondContact = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.send_contact_message, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error responding to contact:', error);
    throw error;
  }
};

// SETTING APIS INTEGRATION
export const getEmailTemplate = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_email_templates, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const deleteEmailTemplate = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(api.delete_email_template, {
      headers: {
        Authorization: `Bearer ${token}`
        // 'Content-Type': 'application/json'
      },
      params: {
        id: id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting email template:', error);
    throw error;
  }
};

export const chnageEmailStatus = async (id, payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      api.change_email_template_status,
      { id, ...payload },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const getFormTypes = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_form_types, {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const addEditEmailTemplate = async (id, payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      api.add_edit_email_template,
      { id, ...payload },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};

export const makeActivePrivacy = async (id, is_best) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      api.change_privacy_status,
      { id, is_best },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating privacy policy status:', error);
    throw error;
  }
};

export const makeActiveTerms = async (id, is_best) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      api.change_terms_status,
      { id, is_best },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating privacy policy status:', error);
    throw error;
  }
};
export const toggleBestFeature = async (id, is_best) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      api.toggle_best_feature_list,
      { id, is_best },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating privacy policy status:', error);
    throw error;
  }
};

export const getSettingTabs = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_setting_tabs, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching Setting tabs:', error);
    throw error;
  }
};

export const getSettingData = async (typeId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${api.get_setting_main}?type_id=${typeId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching Setting data:', error);
    throw error;
  }
};

export const postSettingData = async (finalPayload) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(api.save_setting_main, finalPayload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error adding/editing settings:', error);
    throw error;
  }
};
export const getListing = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_listing_status, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching Setting tabs:', error);
    throw error;
  }
};

export const getSpecifications = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_specifications, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching Setting tabs:', error);
    throw error;
  }
};

// TWO STEP VERIFICATION
export const postSettingToggle = async (payload, token) => {
  try {
    // const token = localStorage.getItem('token');

    const response = await axios.post(api.postSettingToggle, payload, {
      headers: {
        Authorization: `Bearer ${token || localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });

    return response;
  } catch (error) {
    console.error('Error updating toggle:', error);
    throw error;
  }
};

export const getTwoStepToggle = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_twoStepToggle, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

export const verifyOTP = async (payload) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(api.verifyOTP, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response;
  } catch (error) {
    console.error('Error updating toggle:', error);
    throw error;
  }
};

export const getTourTypes = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_tour_inquiry_types, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching features list:', error);
    throw error;
  }
};

// VALUATION TOOL
export const get_valuation_tool = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_valuation_tool, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching valuation tools:', error);
    throw error;
  }
};

export const add_edit_valuation_tool = async (payload) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(api.add_valuation_tool, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response;
  } catch (error) {
    console.error('Error updating toggle:', error);
    throw error;
  }
};

export const delete_valuation_tool = async (valuationId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(api.delete_valuation_tool, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        id: valuationId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting property:', error);
    throw error;
  }
};
export const get_valuation_area_unit = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_area_units_valuation, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching area units:', error);
    throw error;
  }
};

export const get_valuation_types = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_area_units_valuation_types, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching valuation types:', error);
    throw error;
  }
};

export const get_valuation_states = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_valuation_states, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching states:', error);
    throw error;
  }
};

export const get_valuation_cities = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_valuation_cities, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cities:', error);
    throw error;
  }
};

export const getAdvancePrice = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_advance_filter_price_range, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching advance filter:', error);
    throw error;
  }
};

// export const getSubCategory = async () => {
//   try {
//     const token = localStorage.getItem('token');
//     const response = await axios.get(api.get_sub_categories, {
//       headers: {
//         Authorization: `Bearer ${token}`
//       }
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching advance filter:', error);
//     throw error;
//   }
// };

export const getSubCategory = async (feature_category_id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_sub_categories, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        feature_category_id: feature_category_id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const saveSubCategories = async (payload) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(api.save_sub_categories, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response;
  } catch (error) {
    console.error('Error updating toggle:', error);
    throw error;
  }
};
export const getCrmSettings = async () => {
  try {
    const response = await axios.get(api.crm_settings);
    return response.data;
  } catch (error) {
    console.error('Error fetching advance filter:', error);
    throw error;
  }
};

// DASHBOARD PAGE APIS

export const get_dashboard_listings = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_dashboard_listings, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching advance filter:', error);
    throw error;
  }
};

export const get_dashboard_graph = async (period = '') => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.get(api.get_properties_for_graph, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        ...(period && { filter: period })
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching graph data:', error);
    throw error;
  }
};

export const get_performance_chart = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_performance_chart, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching advance filter:', error);
    throw error;
  }
};

export const get_recent_activity_types = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_recent_log_types, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching advance filter:', error);
    throw error;
  }
};

export const get_recent_activity = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_recent_activities, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching advance filter:', error);
    throw error;
  }
};

export const get_recent_activity_deatils = async (params = {}) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(api.get_recent_activity_page, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching recent activity details:', error);
    throw error;
  }
};

// DASHBOARD PAGE APIS
export const get_valuation_email = async () => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.get(api.get_valuation_data_for_email, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        form_type: 8
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching valuation tools:', error);
    throw error;
  }
};
export const respond_valuation = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(api.send_valuation_message, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error responding to contact:', error);
    throw error;
  }
};

export const get_crm_logo_favicon = async () => {
  try {
    const response = await axios.get(api.get_crm_logo_favicon);
    return response.data;
  } catch (error) {
    console.error('Error fetching valuation tools:', error);
    throw error;
  }
};
